module.exports = __webpack_public_path__ + "img/hotel1_min.15dd9530.png";